// Services API — typed fetch wrapping `safeFetch`. The services catalog
// is public (no auth) and reads are idempotent, so there are no mutations
// here. Admin-side CRUD lives in `features/admin/*` and uses
// `adminKeys`.

import { safeFetch } from '../../shared/api/client';
import { API } from '../../shared/api/endpoints';
import type { Service } from '../../shared/types';

export async function fetchServices(): Promise<Service[]> {
  return (await safeFetch(API.services)) as Service[];
}

/** Public per-product detail (migration 063). Throws an ApiError on 404. */
export async function fetchServiceBySlug(slug: string): Promise<Service> {
  return (await safeFetch(API.serviceBySlug(slug))) as Service;
}
